module.exports = __webpack_public_path__ + "media/cash.a0dd94f6.mp3";